module.exports = require("./classCallCheck.js");


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/helpers/class-call-check.js
// module id = 114
// module chunks = 13